export default "__VITE_PUBLIC_ASSET__658c287a__"